import { AuthenticationService } from '../services';
import * as i0 from "@angular/core";
import * as i1 from "../services/authentication.service";
var ResetGuard = /** @class */ (function () {
    function ResetGuard(authService) {
        this.authService = authService;
    }
    ResetGuard.prototype.canActivate = function (next, state) {
        return this.authService.checkPasswordResetAviability(next.queryParams);
    };
    ResetGuard.ngInjectableDef = i0.defineInjectable({ factory: function ResetGuard_Factory() { return new ResetGuard(i0.inject(i1.AuthenticationService)); }, token: ResetGuard, providedIn: "root" });
    return ResetGuard;
}());
export { ResetGuard };
